import { ChangeDetectionStrategy, Component, inject, input, OnInit, output } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../components/state/state.component';
import { TournamentApiService } from '../../../apis/tournament/tournament-api.service';
import { MatDialog } from '@angular/material/dialog';
import { ITournamentPlayerModel, ITournamentTeamModel } from '../../../apis/tournament/model/tournament.model';
import { CreatePlayerDialogComponent } from '../create-player-dialog/create-player-dialog.component';
import { MatButton } from '@angular/material/button';

import { MatList, MatListItem } from '@angular/material/list';
import { LoadingContainerComponent } from '../../../components/loading-container/loading-container.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'oo-team-players-list',
  templateUrl: './team-players-list.component.html',
  styleUrls: ['./team-players-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingContainerComponent, MatList, MatListItem, MatButton],
})
export class TeamPlayersListComponent extends StateComponent<TeamPlayersListComponentState> implements OnInit {

  team = input.required<ITournamentTeamModel>();
  isManageable = input.required<boolean>();
  deactivateTeam = output<number>();
  activateTeam = output<number>();
  state: TeamPlayersListComponentState = {
    status: 'ready',
    players: [],
  };
  private readonly tourApi = inject(TournamentApiService);
  private readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    this.fetchData();
  }

  async openCreatePlayerDialog(): Promise<void> {
    const isCreated = await firstValueFrom(this.dialog.open(CreatePlayerDialogComponent, {
      data: {
        team: this.team(),
      },
    })
      .afterClosed());

    if (isCreated) {
      this.fetchData();
    }
  }

  toggleActivation(isActive: boolean): void {
    if (isActive) {
      this.activateTeam.emit(this.team().id);
    } else {
      this.deactivateTeam.emit(this.team().id);
    }
  }

  private fetchData(): void {
    this.updateStatus('loading');
    this.tourApi.getTournamentPlayers(this.team().tournamentId, [this.team().id])
      .then((players) => {
        this.updateState(
          {
            status: 'ready',
            players,
          },
        );
      })
      .catch((e: Error) => {
        console.error(e);
        this.updateStatus('error');
      });
  }
}

interface TeamPlayersListComponentState {
  status: ComponentStatus;
  players: ITournamentPlayerModel[];
}
